import { useEffect, useState } from "react";

export function useResendTimer(initialSeconds = 60): {
  secondsLeft: number;
  isExpired: boolean;
  reset: () => void;
} {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  const reset = () => setSecondsLeft(initialSeconds);

  return { secondsLeft, isExpired: secondsLeft === 0, reset };
}
